export default class ResetSearchButton {
  methods: {
    resetAll: () => void
  };
  constructor(methods: {
    resetAll: () => void
  },) {
    this.methods = methods;

    Array.from(document.getElementsByClassName('js-reset-search')).forEach((button:any) => {
      button.addEventListener('click', this.methods.resetAll);
    });
  }
}

